if (!customElements.get('default-slider')) {
  class DefaultSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        a11y: {
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
        },
        navigation: {
          nextEl: this.querySelector('.swiper-arrow--next'),
          prevEl: this.querySelector('.swiper-arrow--prev'),
        },
      };

      if (this.hasAttribute('js-reduced-spacing')) {
        this.options.spaceBetween = 8;

        this.options['breakpoints'] = {
          990: {
            spaceBetween: 16,
          },
        };
      }

      if (this.hasAttribute('js-loop')) {
        this.options['loop'] = true;
      }

      if (this.hasAttribute('js-autoplay')) {
        this.options['autoplay'] = {
          delay: Number(this.getAttribute('js-autoplay')),
        };
      }

      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('default-slider', DefaultSlider);
}
